import React from 'react';
import loadable from '@loadable/component';
import getPageDataLoadingAPI from './containers/pageDataLoadingAPI';
import { NotFoundPage } from './containers';

// routeConfiguration needs to initialize containers first
// Otherwise, components will import form container eventually and
// at that point css bundling / imports will happen in wrong order.
import { NamedRedirect } from './components';

const pageDataLoadingAPI = getPageDataLoadingAPI();

//const AboutPage = loadable(() => import(/* webpackChunkName: "AboutPage" */ './containers/AboutPage/AboutPage'));
const FaqPage = loadable(() => import(/* webpackChunkName: "FaqPage" */ './containers/FaqPage/FaqPage'));
const FaqPaymentsPage = loadable(() => import(/* webpackChunkName: "FaqPaymentsPage" */ './containers/FaqPaymentsPage/FaqPaymentsPage'));
const FaqHowUuperPage = loadable(() => import(/* webpackChunkName: "FaqHowUuperPage" */ './containers/FaqHowUuperPage/FaqHowUuperPage'));
const FaqHowUupoPage = loadable(() => import(/* webpackChunkName: "FaqHowUupoPage" */ './containers/FaqHowUupoPage/FaqHowUupoPage'));
const AuthenticationPage = loadable(() => import(/* webpackChunkName: "AuthenticationPage" */ './containers/AuthenticationPage/AuthenticationPage'));
const CheckoutPage = loadable(() => import(/* webpackChunkName: "CheckoutPage" */ './containers/CheckoutPage/CheckoutPage'));
const ContactDetailsPage = loadable(() => import(/* webpackChunkName: "ContactDetailsPage" */ './containers/ContactDetailsPage/ContactDetailsPage'));
const EditListingPage = loadable(() => import(/* webpackChunkName: "EditListingPage" */ './containers/EditListingPage/EditListingPage'));
const EmailVerificationPage = loadable(() => import(/* webpackChunkName: "EmailVerificationPage" */ './containers/EmailVerificationPage/EmailVerificationPage'));
const InboxPage = loadable(() => import(/* webpackChunkName: "InboxPage" */ './containers/InboxPage/InboxPage'));
const LandingPage = loadable(() => import(/* webpackChunkName: "LandingPage" */ './containers/LandingPage/LandingPage'));
const LandingUuper = loadable(() => import(/* webpackChunkName: "LandingUuper" */ './containers/LandingUuper/LandingUuper'));
const LandingUupo = loadable(() => import(/* webpackChunkName: "LandingUupo" */ './containers/LandingUupo/LandingUupo'));
const SeguroUupoPage = loadable(() => import(/* webpackChunkName: "SeguroUupoPage" */ './containers/SeguroUupoPage/SeguroUupoPage'));
const ListingPage = loadable(() => import(/* webpackChunkName: "ListingPage" */ /* webpackPrefetch: true */ './containers/ListingPage/ListingPage'));
const ManageListingsPage = loadable(() => import(/* webpackChunkName: "ManageListingsPage" */ './containers/ManageListingsPage/ManageListingsPage'));
const PasswordChangePage = loadable(() => import(/* webpackChunkName: "PasswordChangePage" */ './containers/PasswordChangePage/PasswordChangePage'));
const PasswordRecoveryPage = loadable(() => import(/* webpackChunkName: "PasswordRecoveryPage" */ './containers/PasswordRecoveryPage/PasswordRecoveryPage'));
const PasswordResetPage = loadable(() => import(/* webpackChunkName: "PasswordResetPage" */ './containers/PasswordResetPage/PasswordResetPage'));
const PaymentMethodsPage = loadable(() => import(/* webpackChunkName: "PaymentMethodsPage" */ './containers/PaymentMethodsPage/PaymentMethodsPage'));
const PrivacyPolicyPage = loadable(() => import(/* webpackChunkName: "PrivacyPolicyPage" */ './containers/PrivacyPolicyPage/PrivacyPolicyPage'));
const CookiesPolicyPage = loadable(() => import(/* webpackChunkName: "CookiesPolicyPage" */ './containers/CookiesPolicyPage/CookiesPolicyPage'));
const CancellationPolicyPage = loadable(() => import(/* webpackChunkName: "CancellationPolicyPage" */ './containers/CancellationPolicyPage/CancellationPolicyPage'));
const CommunicationSafetyPage = loadable(() => import(/* webpackChunkName: "CommunicationSafetyPage" */ './containers/CommunicationSafetyPage/CommunicationSafetyPage'));
const ProfilePage = loadable(() => import(/* webpackChunkName: "ProfilePage" */ './containers/ProfilePage/ProfilePage'));
const ProfileSettingsPage = loadable(() => import(/* webpackChunkName: "ProfileSettingsPage" */ './containers/ProfileSettingsPage/ProfileSettingsPage'));
const RefundPolicyPage = loadable(() => import(/* webpackChunkName: "RefundPolicyPage" */ './containers/RefundPolicyPage/RefundPolicyPage'));
const CausesPolicyPage = loadable(() => import(/* webpackChunkName: "CausesPolicyPage" */ './containers/CausesPolicyPage/CausesPolicyPage'));
const SecurityPriorityPage = loadable(() => import(/* webpackChunkName: "SecurityPriorityPage" */ './containers/SecurityPriorityPage/SecurityPriorityPage'));
const TermProtectionPage = loadable(() => import(/* webpackChunkName: "TermProtectionPage" */ './containers/TermProtectionPage/TermProtectionPage'));
const ProtectionDataPage = loadable(() => import(/* webpackChunkName: "ProtectionDataPage" */ './containers/ProtectionDataPage/ProtectionDataPage'));
const ServicesFreePage = loadable(() => import(/* webpackChunkName: "ServicesFreePage" */ './containers/ServicesFreePage/ServicesFreePage'));
const SearchPage = loadable(() => import(/* webpackChunkName: "SearchPage" */ /* webpackPrefetch: true */  './containers/SearchPage/SearchPage'));
const StripePayoutPage = loadable(() => import(/* webpackChunkName: "StripePayoutPage" */ './containers/StripePayoutPage/StripePayoutPage'));
const TermsOfServicePage = loadable(() => import(/* webpackChunkName: "TermsOfServicePage" */ './containers/TermsOfServicePage/TermsOfServicePage'));
const TransactionPage = loadable(() => import(/* webpackChunkName: "TransactionPage" */ './containers/TransactionPage/TransactionPage'));
const CMSPage = loadable(() => import(/* webpackChunkName: "CMSPage" */ './containers/CMSPage/CMSPage'));
const LandingPageMadrid = loadable(() => import(/* webpackChunkName: "LandingPageMadrid" */ './containers/LandingPageMadrid/LandingPageMadrid'));
const LandingPageBarcelona = loadable(() => import(/* webpackChunkName: "LandingPageBarcelona" */ './containers/LandingPageBarcelona/LandingPageBarcelona'));
const LandingPageValencia = loadable(() => import(/* webpackChunkName: "LandingPageValencia" */ './containers/LandingPageValencia/LandingPageValencia'));
const LandingPageSevilla = loadable(() => import(/* webpackChunkName: "LandingPageSevilla" */ './containers/LandingPageSevilla/LandingPageSevilla'));
const LandingPageACoruna = loadable(() => import(/* webpackChunkName: "LandingPageACoruna" */ './containers/LandingPageACoruna/LandingPageACoruna'));
const LandingPageLeon = loadable(() => import(/* webpackChunkName: "LandingPageLeon" */ './containers/LandingPageLeon/LandingPageLeon'));
const LandingPageSanSebastian = loadable(() => import(/* webpackChunkName: "LandingPageSanSebastian" */ './containers/LandingPageSanSebastian/LandingPageSanSebastian'));
const LandingPageIbiza = loadable(() => import(/* webpackChunkName: "LandingPageIbiza" */ './containers/LandingPageIbiza/LandingPageIbiza'));
const LandingPageMarbella = loadable(() => import(/* webpackChunkName: "LandingPageMarbella" */ './containers/LandingPageMarbella/LandingPageMarbella'));
const LandingPageAlicante = loadable(() => import(/* webpackChunkName: "LandingPageAlicante" */ './containers/LandingPageAlicante/LandingPageAlicante'));
const LandingPagePalmaDeMallorca = loadable(() => import(/* webpackChunkName: "LandingPagePalmaDeMallorca" */ './containers/LandingPagePalmaDeMallorca/LandingPagePalmaDeMallorca'));
const LandingPageOviedo = loadable(() => import(/* webpackChunkName: "LandingPageOviedo" */ './containers/LandingPageOviedo/LandingPageOviedo'));
const LandingPageValladolid = loadable(() => import(/* webpackChunkName: "LandingPageValladolid" */ './containers/LandingPageValladolid/LandingPageValladolid'));
const LandingPageTenerife = loadable(() => import(/* webpackChunkName: "LandingPageTenerife" */ './containers/LandingPageTenerife/LandingPageTenerife'));
const LandingPageGranCanaria = loadable(() => import(/* webpackChunkName: "LandingPageGranCanaria" */ './containers/LandingPageGranCanaria/LandingPageGranCanaria'));
const LandingPageMalaga = loadable(() => import(/* webpackChunkName: "LandingPageMalaga" */ './containers/LandingPageMalaga/LandingPageMalaga'));
const LandingPageZaragoza = loadable(() => import(/* webpackChunkName: "LandingPageZaragoza" */ './containers/LandingPageZaragoza/LandingPageZaragoza'));
const LandingPageVitoria = loadable(() => import(/* webpackChunkName: "LandingPageVitoria" */ './containers/LandingPageVitoria/LandingPageVitoria'));
const LandingPageBilbao = loadable(() => import(/* webpackChunkName: "LandingPageBilbao" */ './containers/LandingPageBilbao/LandingPageBilbao'));
const LandingPagePamplona = loadable(() => import(/* webpackChunkName: "LandingPagePamplona" */ './containers/LandingPagePamplona/LandingPagePamplona'));
const LandingPageVigo = loadable(() => import(/* webpackChunkName: "LandingPageVigo" */ './containers/LandingPageVigo/LandingPageVigo'));
const LandingPageLanzarote = loadable(() => import(/* webpackChunkName: "LandingPageLanzarote" */ './containers/LandingPageLanzarote/LandingPageLanzarote'));
const LandingPageLogrono = loadable(() => import(/* webpackChunkName: "LandingPageLogrono" */ './containers/LandingPageLogrono/LandingPageLogrono'));
const LandingPageMurcia = loadable(() => import(/* webpackChunkName: "LandingPageMurcia" */ './containers/LandingPageMurcia/LandingPageMurcia'));
const LandingPageBurgos = loadable(() => import(/* webpackChunkName: "LandingPageBurgos" */ './containers/LandingPageBurgos/LandingPageBurgos'));
const LandingPageSantander = loadable(() => import(/* webpackChunkName: "LandingPageSantander" */ './containers/LandingPageSantander/LandingPageSantander'));

const LandingPageCities = loadable(() => import(/* webpackChunkName: "LandingPageCities" */ './containers/LandingPageCities/LandingPageCities'));


// Styleguide helps you to review current components and develop new ones
const StyleguidePage = loadable(() => import(/* webpackChunkName: "StyleguidePage" */ './containers/StyleguidePage/StyleguidePage'));

export const ACCOUNT_SETTINGS_PAGES = [
  'ContactDetailsPage',
  'PasswordChangePage',
  'StripePayoutPage',
  'PaymentMethodsPage',
];

// https://en.wikipedia.org/wiki/Universally_unique_identifier#Nil_UUID
const draftId = '00000000-0000-0000-0000-000000000000';
const draftSlug = 'draft';

const RedirectToLandingPage = () => <NamedRedirect name="LandingPage" />;

// NOTE: Most server-side endpoints are prefixed with /api. Requests to those
// endpoints are indended to be handled in the server instead of the browser and
// they will not render the application. So remember to avoid routes starting
// with /api and if you encounter clashing routes see server/index.js if there's
// a conflicting route defined there.

// Our routes are exact by default.
// See behaviour from Routes.js where Route is created.
const routeConfiguration = () => {
  return [
    {
      // path: '/beneficios-de-uupo',
      path: '/publica-tu-escaparate-pop-up',
      name: 'LandingUuper',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      // path: '/beneficios-de-uupo',
      path: '/list-your-pop-up-storefront',
      name: 'LandingUuperEnglish',
      component: LandingPage,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/p/:pageId',
      name: 'CMSPage',
      component: CMSPage,
      loadData: pageDataLoadingAPI.CMSPage.loadData,
    },
    {
      path: '/',
      name: 'LandingPage',
      component: LandingUuper,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/reserva-tu-escaparte-pop-up',
      name: 'LandingUupo',
      component: LandingUupo,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/book-your-pop-up-storefront',
      name: 'LandingUupoEnglish',
      component: LandingUupo,
      loadData: pageDataLoadingAPI.LandingPage.loadData,
    },
    {
      path: '/pop-up-stores-madrid',
      name: 'LandingPageMadrid',
      component: LandingPageMadrid,
    },
    {
      path: '/pop-up-stores-barcelona',
      name: 'LandingPageBarcelona',
      component: LandingPageBarcelona,
    },
    {
      path: '/pop-up-stores-valencia',
      name: 'LandingPageValencia',
      component: LandingPageValencia,
    },
    {
      path: '/pop-up-stores-sevilla',
      name: 'LandingPageSevilla',
      component: LandingPageSevilla,
    },
    {
      path: '/pop-up-stores-a-coruna',
      name: 'LandingPageACoruna',
      component: LandingPageACoruna,
    },
    {
      path: '/pop-up-stores-leon',
      name: 'LandingPageLeon',
      component: LandingPageLeon,
    },
    {
      path: '/pop-up-stores-san-sebastian',
      name: 'LandingPageSanSebastian',
      component: LandingPageSanSebastian,
    },
    {
      path: '/pop-up-stores-ibiza',
      name: 'LandingPageIbiza',
      component: LandingPageIbiza,
    },
    {
      path: '/pop-up-stores-marbella',
      name: 'LandingPageMarbella',
      component: LandingPageMarbella,
    },
    {
      path: '/pop-up-stores-alicante',
      name: 'LandingPageAlicante',
      component: LandingPageAlicante,
    },
    {
      path: '/pop-up-stores-palma-de-mallorca',
      name: 'LandingPagePalmaDeMallorca',
      component: LandingPagePalmaDeMallorca,
    },
    {
      path: '/pop-up-stores-oviedo',
      name: 'LandingPageOviedo',
      component: LandingPageOviedo,
    },
    {
      path: '/pop-up-stores-valladolid',
      name: 'LandingPageValladolid',
      component: LandingPageValladolid,
    },
    {
      path: '/pop-up-stores-tenerife',
      name: 'LandingPageTenerife',
      component: LandingPageTenerife,
    },
    {
      path: '/pop-up-stores-gran-canaria',
      name: 'LandingPageGranCanaria',
      component: LandingPageGranCanaria,
    },
    {
      path: '/pop-up-stores-malaga',
      name: 'LandingPageMalaga',
      component: LandingPageMalaga,
    },
    {
      path: '/pop-up-stores-zaragoza',
      name: 'LandingPageZaragoza',
      component: LandingPageZaragoza,
    },
    {
      path: '/pop-up-stores-vitoria',
      name: 'LandingPageVitoria',
      component: LandingPageVitoria,
    },
    {
      path: '/pop-up-stores-bilbao',
      name: 'LandingPageBilbao',
      component: LandingPageBilbao,
    },
    {
      path: '/pop-up-stores-pamplona',
      name: 'LandingPagePamplona',
      component: LandingPagePamplona,
    },
    {
      path: '/pop-up-stores-vigo',
      name: 'LandingPageVigo',
      component: LandingPageVigo,
    },
    {
      path: '/pop-up-stores-lanzarote',
      name: 'LandingPageLanzarote',
      component: LandingPageLanzarote,
    },
    {
      path: '/pop-up-stores-logrono',
      name: 'LandingPageLogrono',
      component: LandingPageLogrono,
    },
    {
      path: '/pop-up-stores-murcia',
      name: 'LandingPageMurcia',
      component: LandingPageMurcia,
    },
    {
      path: '/pop-up-stores-burgos',
      name: 'LandingPageBurgos',
      component: LandingPageBurgos,
    },

    // add for Santander
    {
      path: '/pop-up-stores-santander',
      name: 'LandingPageSantander',
      component: LandingPageSantander,
    },

    {
      path: '/pop-up-stores-cities', // Or another desired path
      name: 'LandingPageCities',
      component: LandingPageCities,
      // Add loadData if needed, similar to other landing pages
    },
    // {
    //   path: '/about',
    //   name: 'AboutPage',
    //   component: AboutPage,
    // },
    {
      path: '/faq-cuenta',
      name: 'FaqPage',
      component: FaqPage,
    },
    {
      path: '/faq-pagos-obligaciones-fiscales',
      name: 'FaqPaymentsPage',
      component: FaqPaymentsPage,
    },
    {
      path: '/faq-uuper',
      name: 'FaqHowUuperPage',
      component: FaqHowUuperPage,
    },
    {
      path: '/faq-uupo',
      name: 'FaqHowUupoPage',
      component: FaqHowUupoPage,
    },
    {
      path: '/s',
      name: 'SearchPage',
      component: SearchPage,
      loadData: pageDataLoadingAPI.SearchPage.loadData,
    },
    {
      path: '/l',
      name: 'ListingBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/l/:slug/:id',
      name: 'ListingPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/checkout',
      name: 'CheckoutPage',
      auth: true,
      component: CheckoutPage,
      setInitialValues: pageDataLoadingAPI.CheckoutPage.setInitialValues,
    },
    {
      path: '/l/:slug/:id/:variant',
      name: 'ListingPageVariant',
      auth: true,
      authPage: 'LoginPage',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/l/new',
      name: 'NewListingPage',
      auth: true,
      component: () => (
        <NamedRedirect
          name="EditListingPage"
          params={{ slug: draftSlug, id: draftId, type: 'new', tab: 'features' }}
        />
      ),
    },
    {
      path: '/l/:slug/:id/:type/:tab',
      name: 'EditListingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },
    {
      path: '/l/:slug/:id/:type/:tab/:returnURLType',
      name: 'EditListingStripeOnboardingPage',
      auth: true,
      component: EditListingPage,
      loadData: pageDataLoadingAPI.EditListingPage.loadData,
    },

    // Canonical path should be after the `/l/new` path since they
    // conflict and `new` is not a valid listing UUID.
    {
      path: '/l/:id',
      name: 'ListingPageCanonical',
      component: ListingPage,
      loadData: pageDataLoadingAPI.ListingPage.loadData,
    },
    {
      path: '/u',
      name: 'ProfileBasePage',
      component: RedirectToLandingPage,
    },
    {
      path: '/u/:id',
      name: 'ProfilePage',
      component: ProfilePage,
      loadData: pageDataLoadingAPI.ProfilePage.loadData,
    },
    {
      path: '/profile-settings',
      name: 'ProfileSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ProfileSettingsPage,
    },

    // Note: authenticating with IdP (e.g. Facebook) expects that /login path exists
    // so that in the error case users can be redirected back to the LoginPage
    // In case you change this, remember to update the route in server/api/auth/loginWithIdp.js
    {
      path: '/login',
      name: 'LoginPage',
      component: AuthenticationPage,
      extraProps: { tab: 'login' },
    },
    {
      path: '/registro',
      name: 'SignupPage',
      component: AuthenticationPage,
      extraProps: { tab: 'signup' },
    },
    {
      path: '/confirm',
      name: 'ConfirmPage',
      component: AuthenticationPage,
      extraProps: { tab: 'confirm' },
    },
    {
      path: '/recover-password',
      name: 'PasswordRecoveryPage',
      component: PasswordRecoveryPage,
    },
    {
      path: '/inbox',
      name: 'InboxBasePage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="InboxPage" params={{ tab: 'sales' }} />,
    },
    {
      path: '/inbox/:tab',
      name: 'InboxPage',
      auth: true,
      authPage: 'LoginPage',
      component: InboxPage,
      loadData: pageDataLoadingAPI.InboxPage.loadData,
    },
    {
      path: '/order/:id',
      name: 'OrderPage',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="OrderDetailsPage" params={{ ...props.params }} />,
    },
    {
      path: '/order/:id/details',
      name: 'OrderDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'customer' },
      loadData: params =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'customer' }),
      setInitialValues: pageDataLoadingAPI.TransactionPage.setInitialValues,
    },
    {
      path: '/sale/:id',
      name: 'SalePage',
      auth: true,
      authPage: 'LoginPage',
      component: props => <NamedRedirect name="SaleDetailsPage" params={{ ...props.params }} />,
    },
    {
      path: '/sale/:id/details',
      name: 'SaleDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: TransactionPage,
      extraProps: { transactionRole: 'provider' },
      loadData: params =>
        pageDataLoadingAPI.TransactionPage.loadData({ ...params, transactionRole: 'provider' }),
    },
    {
      path: '/listings',
      name: 'ManageListingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ManageListingsPage,
      loadData: pageDataLoadingAPI.ManageListingsPage.loadData,
    },
    {
      path: '/account',
      name: 'AccountSettingsPage',
      auth: true,
      authPage: 'LoginPage',
      component: () => <NamedRedirect name="ContactDetailsPage" />,
    },
    {
      path: '/account/contact-details',
      name: 'ContactDetailsPage',
      auth: true,
      authPage: 'LoginPage',
      component: ContactDetailsPage,
      loadData: pageDataLoadingAPI.ContactDetailsPage.loadData,
    },
    {
      path: '/account/change-password',
      name: 'PasswordChangePage',
      auth: true,
      authPage: 'LoginPage',
      component: PasswordChangePage,
    },
    {
      path: '/account/payments',
      name: 'StripePayoutPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payments/:returnURLType',
      name: 'StripePayoutOnboardingPage',
      auth: true,
      authPage: 'LoginPage',
      component: StripePayoutPage,
      loadData: pageDataLoadingAPI.StripePayoutPage.loadData,
    },
    {
      path: '/account/payment-methods',
      name: 'PaymentMethodsPage',
      auth: true,
      authPage: 'LoginPage',
      component: PaymentMethodsPage,
      loadData: pageDataLoadingAPI.PaymentMethodsPage.loadData,
    },
    {
      path: '/terminos-condiciones',
      name: 'TermsOfServicePage',
      component: TermsOfServicePage,
    },
    {
      path: '/protocolo-proteccion-datos-politica-privacidad',
      name: 'PrivacyPolicyPage',
      component: PrivacyPolicyPage,
    },
    {
      path: '/politicas-cookies',
      name: 'CookiesPolicyPage',
      component: CookiesPolicyPage,
    },
    {
      path: '/u-seguro',
      name: 'SeguroUupoPage',
      component: SeguroUupoPage,
    },
    {
      path: '/tu-seguridad-nuestra-prioridad',
      name: 'SecurityPriorityPage',
      component: SecurityPriorityPage,
    },
    {
      path: '/seguridad-en-la-comunication',
      name: 'CommunicationSafetyPage',
      component: CommunicationSafetyPage,
    },
    {
      path: '/terminos-proteccion-danos',
      name: 'TermProtectionPage',
      component: TermProtectionPage,
    },
    {
      path: '/hoja-informativa-proteccion-datos',
      name: 'ProtectionDataPage',
      component: ProtectionDataPage,
    },
    {
      path: '/politica-cancelacion',
      name: 'CancellationPolicyPage',
      component: CancellationPolicyPage,
    },
    {
      path: '/politica-reembolso',
      name: 'RefundPolicyPage',
      component: RefundPolicyPage,
    },
    {
      path: '/politica-causas-fuerza-mayor',
      name: 'CausesPolicyPage',
      component: CausesPolicyPage,
    },
    {
      path: '/tarifa-servicio-uupo',
      name: 'ServicesFreePage',
      component: ServicesFreePage,
    },
    {
      path: '/styleguide',
      name: 'Styleguide',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/g/:group',
      name: 'StyleguideGroup',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component',
      name: 'StyleguideComponent',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example',
      name: 'StyleguideComponentExample',
      component: StyleguidePage,
    },
    {
      path: '/styleguide/c/:component/:example/raw',
      name: 'StyleguideComponentExampleRaw',
      component: StyleguidePage,
      extraProps: { raw: true },
    },
    {
      path: '/notfound',
      name: 'NotFoundPage',
      component: props => <NotFoundPage {...props} />,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /reset-password endpoint
    {
      path: '/reset-password',
      name: 'PasswordResetPage',
      component: PasswordResetPage,
    },

    // Do not change this path!
    //
    // The API expects that the application implements /verify-email endpoint
    {
      path: '/verify-email',
      name: 'EmailVerificationPage',
      auth: true,
      authPage: 'LoginPage',
      component: EmailVerificationPage,
      loadData: pageDataLoadingAPI.EmailVerificationPage.loadData,
    },
  ];
};

export default routeConfiguration;
